import * as React from "react";
import {translate, Trans} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import {Container,Row,Col} from "reactstrap";
import vodafoneLogo from "../../media/icons/vf-logo.png";

import iconError from "../../media/icons/error.svg"

class StageError extends React.Component {

    // initialize Component state

    constructor(props){
        super(props);
    }


    render() {
        return <Container>
		<MobileView>
			<Row className={"header"}>
                        <Col xs={2} style={{marginLeft:"-15px"}}>
                            <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                        </Col>
                    </Row>
			<Row style={{paddingTop:"5vh"}}>
                <Col xs={{ size: 12 }}>
                    <Header
                        textResource={"installed_title"}
                    />
                </Col>
            </Row>
            <Row style={{paddingTop:"20px"}}>
                <Col xs={{ size: 12 }}>
                    <TextBody
                        textResource={"installed_body_1"}
                        emoji_heart = "&#128150;"
                    />
                </Col>
            </Row>
			<Row style={{paddingTop:"20px"}}>
                <Col xs={{ size: 12 }}>
                    <TextBody
                        textResource={"installed_body_2"}
                    />
                </Col>
            </Row>
			<Row style={{paddingTop:"20px"}}>
                <Col xs={{ size: 12 }}>
                    <TextBody
                        textResource={"installed_body_3"}
                        emoji_up = "&#128077;"
                    />
                </Col>
            </Row>
		</MobileView>
		<BrowserView>
            <Row className={"header desktop"}>
						<Col xs={12}>
							<div className={"container"}>
								<Row>
									<Col xs={2} style={{marginLeft:"-15px"}}>
										<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
									</Col>
								</Row>
							</div>
						</Col>
                    </Row>
			<Row style={{paddingTop:"20vh"}}>
                <Col xs={{ size: 10, offset: 1 }}>
                    <Header
                        textResource={"installed_title"}
                    />
                </Col>
            </Row>
            <Row style={{paddingTop:"20px"}}>
                <Col xs={{ size: 10, offset: 1 }}>
                    <TextBody
                        textResource={"installed_body_1"}
                        emoji_heart = "&#128150;"
                    />
                </Col>
            </Row>
			<Row style={{paddingTop:"20px"}}>
                <Col xs={{ size: 10, offset: 1 }}>
                    <TextBody
                        textResource={"installed_body_2"}
                    />
                </Col>
            </Row>
			<Row style={{paddingTop:"20px"}}>
                <Col xs={{ size: 10, offset: 1 }}>
                    <TextBody
                        textResource={"installed_body_3"}
                        emoji_up = "&#128077;"
                    />
                </Col>
            </Row>
		</BrowserView>
        </Container>
}
}

export default translate("translations")(StageError);